import React from "react";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  // Helper function to navigate to courses
  const navigateToCourses = () => {
    navigate("/courses");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer id="contact" className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="py-16">
          <div className="grid lg:grid-cols-4 md:grid-cols-2 gap-8">
            {/* Quick Links */}
            <div>
              <h4 className="text-lg font-semibold mb-6">Quick Links</h4>
              <ul className="space-y-3">
                <li>
                  <button
                    onClick={() => {
                      navigate("/");
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    Home
                  </button>
                </li>
                <li>
                  <button
                    onClick={navigateToCourses}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    Courses
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => {
                      navigate("/services");
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    Services
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => {
                      navigate("/courses");
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    Courses
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => {
                      navigate("/about");
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    About Us
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => {
                      navigate("/contact");
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    Contact Us
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => {
                      navigate("/enroll");
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    Enroll Now
                  </button>
                </li>
              </ul>
            </div>

            {/* Courses */}
            <div>
              <h4 className="text-lg font-semibold mb-6">Our Courses</h4>
              <ul className="space-y-3">
                <li>
                  <button
                    onClick={() => {
                      navigate("/java-full-stack");
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    Java Full Stack Course
                  </button>
                </li>
                <li>
                  <button
                    onClick={navigateToCourses}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    MERN Stack Development
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => {
                      navigate("/python-full-stack");
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    Python Full Stack Development
                  </button>
                </li>
                <li>
                  <button
                    onClick={() => {
                      navigate("/dotnet-full-stack");
                      window.scrollTo({ top: 0, behavior: "smooth" });
                    }}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    .NET Full Stack Development
                  </button>
                </li>
                <li>
                  <button
                    onClick={navigateToCourses}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    AI & Machine Learning
                  </button>
                </li>
                <li>
                  <button
                    onClick={navigateToCourses}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    Frontend Development
                  </button>
                </li>
                <li>
                  <button
                    onClick={navigateToCourses}
                    className="text-gray-400 hover:text-white transition-colors"
                  >
                    Mobile App Development
                  </button>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h4 className="text-lg font-semibold mb-6">Contact Us</h4>
              <div className="space-y-4">
                <div className="flex items-start">
                  <span className="text-primary-400 mr-3 mt-1">📍</span>
                  <div>
                    <p className="text-gray-400">
                      Neuro Edge Technologies
                      <br />
                      4th Floor, Office No 401
                      <br />
                      Vishwaraj Pride,Opposite Zudio, Wagholi, Pune
                      <br />
                      Maharashtra Pune 412207
                    </p>
                  </div>
                </div>

                <div className="flex items-center">
                  <span className="text-primary-400 mr-3">📞</span>
                  <div>
                    <p className="text-gray-400">+91-8055006652</p>
                  </div>
                </div>

                <div className="flex items-center">
                  <span className="text-primary-400 mr-3">✉️</span>
                  <div>
                    <p className="text-gray-400">
                      info@neuroedgetechnologies.com
                    </p>
                  </div>
                </div>

                <div className="flex items-center">
                  <span className="text-primary-400 mr-3">🕒</span>
                  <div>
                    <p className="text-gray-400">
                      Mon - Sat: 9:00 AM - 6:00 PM
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Company Details - 4th Column */}
            <div>
              <h4 className="text-lg font-semibold mb-6">Company Info</h4>
              <div className="space-y-4">
                <div>
                  <p className="text-gray-400 text-sm mb-2">
                    <span className="text-gray-300 font-semibold">
                      Company Registration:
                    </span>
                  </p>
                  <p className="text-gray-400 text-sm font-mono bg-gray-800 p-2 rounded">
                    ACT-8200
                  </p>
                </div>

                <div>
                  <p className="text-gray-400 text-sm mb-2">
                    <span className="text-gray-300 font-semibold">
                      TAN Number:
                    </span>
                  </p>
                  <p className="text-gray-400 text-sm font-mono bg-gray-800 p-2 rounded">
                    NSKN08781D
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="border-t border-gray-800 py-8">
          <div className="grid md:grid-cols-2 gap-4 items-center">
            <div className="text-gray-400 text-sm">
              © {currentYear} Neuro Edge Technologies. All rights reserved.
            </div>
            <div></div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
